export default "__VITE_ASSET__19abf4df__"